import React, { Component } from 'react';
import { Button, Popover } from 'reactstrap';
import PropTypes from 'prop-types';
import './CheckedMenu.css';

class CheckedMenu extends Component {
  static propTypes = {
    menuKey: PropTypes.string.isRequired,
    containerClassName: PropTypes.string,
    popoverClassName: PropTypes.string,
    buttonComponent: PropTypes.any,
    buttonName: PropTypes.string,
    detailsMenu: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        id: PropTypes.string,
        onClick: PropTypes.func,
        checked: PropTypes.bool
      })
    ).isRequired,
    isBig: PropTypes.bool
  };
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  toggleMenu = () => this.setState(state => ({ isOpen: !state.isOpen }));

  onMenuItemClick = onClick => {
    if (onClick) {
      onClick();
    }
  };

  render() {
    const { menuKey, containerClassName, popoverClassName, detailsMenu, isBig, buttonComponent } = this.props;
    return (
      <div className={`detailsCheckedMenu ${containerClassName}`}>
        <div>
          <div className="buttonComponent" onClick={this.toggleMenu} id={`checked_menu_btn_${menuKey}`}>
            {buttonComponent ? buttonComponent : this.getDefaultButton(isBig)}
          </div>
        </div>
        <Popover
          placement="bottom"
          hideArrow={true}
          isOpen={this.state.isOpen}
          target={`checked_menu_btn_${menuKey}`}
          toggle={this.toggleMenu}
          className={`popover ${popoverClassName}`}>
          <div className={'checkedMenuOptions'}>
            {detailsMenu.map(element => (
              <div key={element.id} className="dropdown-item" onClick={() => this.onMenuItemClick(element.onClick)}>
                <input type="checkbox" checked={element.checked} />
                <div className="itemText">{element.text}</div>
              </div>
            ))}
          </div>
        </Popover>
      </div>
    );
  }

  getDefaultButton = isBig => {
    const { buttonName } = this.props;
    if (isBig) {
      return (
        <Button color="link" className="checkedMenuDefaultButton">
          {buttonName}
        </Button>
      );
    } else {
      return <i className={`togo-icon togo-icon-list`} onClick={this.toggleMenu} />;
    }
  };
}

export default CheckedMenu;



// WEBPACK FOOTER //
// ./src/Components/CheckedMenu/CheckedMenu.js